let id = 1;
export function uniqueId(prefix = 'uniq') {
  return `${prefix}${id++}`;
}